import React from "react";
import { FooterBrand, FooterContact, FooterHours, FooterBottom } from "../footer/FooterParts";
import { ServiceArea } from "../ServiceArea";

export default function Footer({ t }) {
  return (
    <footer data-testid="site-footer" className="bg-brand-dark text-white pt-16 pb-28 md:pb-12">
      <div className="max-w-7xl mx-auto px-5 md:px-8 lg:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-12">
          <FooterBrand t={t} />
          <FooterContact t={t} />
          <FooterHours t={t} />
        </div>
        <div className="mt-10">
          <ServiceArea t={t} theme="dark" testId="footer-service-area" compact />
        </div>
        <FooterBottom t={t} />
      </div>
    </footer>
  );
}
